import { LetterImage } from "src/js/stores/letter/store";
import { UserImageDTO } from "@landtechnologies/dtos";

export function toUserImageDTO(image?: LetterImage): UserImageDTO | undefined {
  if (!image) {
    return undefined;
  }

  if (!image.s3ObjectKey && !image.url) {
    return undefined;
  }

  return {
    s3ObjectKey: image.s3ObjectKey,
    url: image.url,
  };
}
